angular.module("UI8.directives").directive("ui8LazyLoad", [
  function () {
    var $win = $(window);

    /**
     * Called on directive init
     * @param  {object} scope   Private scope
     * @param  {object} element jQ wrapped element
     * @return {undefined}
     */
    function linker(scope, element) {
      var el = scope.container ? scope.container : $win;

      function scrollHandler() {
        // Lazy is disabled
        if (scope.disable) return;

        // If element is visible
        if (elementIsVisible()) return scope.whenVisible();
      }

      // On viewports tall enough that the content never overflows, no
      // scroll event can ever fire — poll visibility so the next pages
      // keep loading until the viewport fills or results run out. The
      // consumer's in-flight guard (e.g. ctrl.searching) makes repeated
      // calls safe.
      var pollId = setInterval(scrollHandler, 400);

      // Per-instance namespace so one loader's teardown can't detach a
      // sibling's handlers
      var ns = ".cdlazyload" + scope.$id;

      scope.$on("$destroy", function () {
        el.off("scroll" + ns);
        $win.off("resize" + ns);
        clearInterval(pollId);
      });

      // Listen for scroll and viewport changes
      el.on("scroll" + ns, scrollHandler);
      $win.on("resize" + ns, scrollHandler);

      /**
       * Determine if element is visible on screen
       * @return {Boolean}        If element is visible
       */
      function elementIsVisible() {
        var containerTop, containerBottom, elemTop, elemBottom;

        if (scope.container) {
          containerTop = scope.container.offset().top;
          containerBottom = containerTop + scope.container.height();
          // Trigger lazy load when loader element is 50px lower than bottom of container
          elemTop = element.offset().top - 50;
          elemBottom = elemTop + element.height();
        } else {
          containerTop = $win.scrollTop();
          containerBottom = containerTop + $win.height();
          elemTop = element.offset().top;
          elemBottom = elemTop + element.height();
        }

        return elemBottom <= containerBottom && elemTop >= containerTop;
      }
    }

    // Public API
    return {
      link: linker,
      scope: {
        disable: "=",
        container: "=",
        whenVisible: "&",
      },
      restrict: "A",
    };
  },
]);
